module.exports = __webpack_public_path__ + "img/target_map.e8cf8965.jpg";